import { Box } from '@global-engineering-shared/gweb-material-ui';
import { combineClasses } from '@global-engineering-shared/object-utils';
import Collapse from '@material-ui/core/Collapse';
import classNames from 'classnames';
import { CSSProperties, useState } from 'react';

import TableExpandButton from 'components/Table/components/TableItem/components/TableExpandButton';
import TableListItem from 'components/Table/components/TableItem/components/TableListItem';
import useStyles from 'components/Table/components/TableItem/TableItem.styles';
import { ITableItem } from 'components/Table/types/Table';

const TableItem = (props: ITableItem) => {
  const {
    item,
    collapsedContent,
    handleRowClick,
    columns,
    tableItemGridTemplate,
    keyName,
    classes: userClasses = {},
    expandOnClick,
    itemStyle,
  } = props;
  const [isExpanded, setIsExpanded] = useState(false);
  const classes = combineClasses(useStyles({ isExpanded }), userClasses);

  const getItemStyle = (): CSSProperties => {
    if (itemStyle) {
      return itemStyle(item);
    }
    return {};
  };

  return (
    <Box className={classNames(classes.tableItem, classes.root)} style={getItemStyle()}>
      <Box className={classes.itemSection}>
        <Box className={classes.itemContainer}>
          <TableExpandButton
            expandOnClick={expandOnClick}
            isExpanded={isExpanded}
            setIsExpanded={setIsExpanded}
            hideTitleAccessText="Hide frame details"
            showTitleAccessText="Show frame details"
          />
          <TableListItem
            item={item}
            columns={columns}
            keyName={keyName}
            handleRowClick={handleRowClick}
            isExpanded={isExpanded}
            expandOnClick={expandOnClick}
            tableItemGridTemplate={tableItemGridTemplate}
          />
        </Box>
        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          <Box className={classes.subItemContainer}>
            {collapsedContent && collapsedContent(item)}
          </Box>
        </Collapse>
      </Box>
    </Box>
  );
};

export default TableItem;
